function Jobs(){
	this.init();
}

Jobs.prototype.checkFilter = function(){
	var url = "?";
	$.each($('.jobs_filter'), function(i, v) {
		if ($(v).val())
			url += '&'+$(v).attr('name') + "=" + $(v).val();
	});
	if (url != this.last_url) {
		this.last_url = url;
		window.location = this.base_url + url;
	}
};

Jobs.prototype.init = function(){
	var self = this;
	var filters = $('.jobs-filters').length;
	if (filters) {
		var last_url = "?";
		$.each($('.jobs_filter'), function(i, v) {
			if ($(v).val())
				last_url += '&'+$(v).attr('name') + "=" + $(v).val();
		});
		this.last_url = last_url;
		var isScroll = $('.jobs-filters').attr('data-scroll');
		if (isScroll) {
			$(window).scrollTo( $('.jobs-filters').offset().top - 100 );
		}
		this.base_url = $('.jobs-filters').attr('data-category');
		var int = setInterval(function() {
			self.checkFilter();
		}, 100);
	}
};